import { render } from "./iban-reupload.vue?vue&type=template&id=0f00e4c1"
import script from "./iban-reupload.vue?vue&type=script&lang=js"
export * from "./iban-reupload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__